import type { IconProps } from '@mote/ui/components/icon'
import { pxTorem } from '@mote/ui/theme/utils'

export const defaultProps: IconProps = {
  width: pxTorem(24).themeValue,
  height: pxTorem(24).themeValue,
  fill: 'none'
}
